<template>
  <div class="comment">
    <div class="search-header">
      <div class="content">
        <el-input
          size="small"
          :placeholder= searchPlaceholder
          v-model="projectOrder.searchParam"
          class="input-with-select"
          clearable
          v-noEmoji
           maxlength="45"
           @keyup.enter.native="handleSearch"
        >
          <el-select slot="prepend" v-model="projectOrder.selectNameType" placeholder="请选择">
            <el-option
              v-for="item in selectNameList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small"
            ></el-option>
          </el-select>
          <el-button @click="handleSearch" slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="content">
        <el-popover placement="bottom" trigger="click" popper-class="ad-popover">
          <el-form
            ref="selectForm"
            :modl="selectForm"
            class="demo-form"
            label-position="left"
            label-width="100px"
            size="small"
          >
            <div class="popover-title">项目订单</div>
            <div class="demo-form-box">
              <el-form-item label="订单状态">
                <el-select
                  v-model="selectForm.orderStatus"
                  clearable
                  placeholder="请选择"
                  class="demo-form-select"
                >
                  <el-option
                    v-for="item in orderStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="广告主" v-show="projectOrder.accountType === '1'">
                  <el-input
                  v-model="selectForm.orderPartnerName"
                  clearable
                  v-noEmoji
                  class="demo-form-input"
                  placeholder="请输入"
                  @keyup.enter.native="handleSearch"
                  maxlength="45"
                ></el-input>
              </el-form-item>
              <el-form-item label="投放时间">
                <el-date-picker
                  v-model="selectForm.contractTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  class="demo-form-picker"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="购买方式">
                <el-select clearable v-model="selectForm.buyType" class="demo-form-select">
                    <el-option v-for="(item,index) in buyTypeOptions" :value="item.value" :key="'p'+index" :label="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="popover-title">投放计划</div>
            <div class="demo-form-box">
              <el-form-item label="广告主" v-show="projectOrder.accountType === '1'">
                <el-input
                  v-model="selectForm.schedulePartnerName"
                  clearable
                  v-noEmoji
                  class="demo-form-input"
                  placeholder="请输入"
                  @keyup.enter.native="handleSearch"
                  maxlength="45"
                ></el-input>
              </el-form-item>
              <el-form-item label="计划状态">
                <el-select
                  v-model="selectForm.scheduleStatus"
                  clearable
                  placeholder="请选择"
                  class="demo-form-select"
                >
                  <el-option
                    v-for="item in scheduleStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="ERP子单号">
                <el-input
                  v-model="selectForm.erpSubOrder"
                  clearable
                  v-noEmoji
                  class="demo-form-input"
                  placeholder="请输入ERP子单号"
                  maxlength="45"
                  @keyup.enter.native="handleSearch"
                ></el-input>
              </el-form-item>
              <el-form-item label="子单状态">
                <el-select v-model="selectForm.erpSubOrderStatus" clearable class="demo-form-select">
                  <el-option  :value="0" label="启用"></el-option>
                  <el-option  :value="1" label="暂停"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="ERP产品编码">
                <el-input
                  v-model="selectForm.erpMaterialCode"
                  clearable
                  v-noEmoji
                  class="demo-form-input"
                  placeholder="请输入ERP产品编码"
                  maxlength="45"
                  @keyup.enter.native="handleSearch"
                ></el-input>
              </el-form-item>
               <el-form-item label="投放时间">
                <el-date-picker
                  v-model="selectForm.putTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                  class="demo-form-picker"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="广告位">
                <el-select
                  v-model="selectForm.scheduleSpaceId"
                  clearable
                  placeholder="请选择"
                  class="demo-form-select"
                >
                  <el-option
                    v-for="item in spaceOptions"
                    :key="'s'+item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="销售方式">
                <el-select clearable v-model="selectForm.saleType"  class="demo-form-select">
                  <el-option v-for="(item,index) in saleTypeOptions" :key="'s'+index" :value="item.value" :label="item.label"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="结算方式">
                <el-select clearable v-model="selectForm.payment"  class="demo-form-select">
                  <el-option v-for="(item,index) in paymentOptions" :key="'s'+index" :value="item.value" :label="item.label"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="程序化来源">
                 <el-select clearable v-model="selectForm.scheduleSource"  class="demo-form-select">
                  <el-option v-for="(item,index) in scheduleSourceOptions" :key="'s'+index" :value="item.value" :label="item.label"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="程序化类型"  >
                <el-select clearable v-model="selectForm.supportMode" class="demo-form-select">
                  <el-option v-for="(item,index) in supportModeOptions" :key="'s'+index" :value="item.value" :label="item.label"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="销售子单号">
                <el-input
                  v-model="selectForm.suborderNo"
                  clearable
                  v-noEmoji
                  class="demo-form-input"
                  placeholder="请输入销售子单号"
                  maxlength="45"
                  @keyup.enter.native="handleSearch"
                ></el-input>
              </el-form-item>
            </div>
            <div class="popover-title">创意</div>
            <div class="demo-form-box">
              <el-form-item label="创意状态">
                <el-select
                  v-model="selectForm.checkStatus"
                  clearable
                  placeholder="请选择"
                  size="small"
                  class="demo-form-select"
                >
                  <el-option
                    v-for="item in mediaStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="创意类型">
                <el-select
                  v-model="selectForm.mediaClassId"
                  clearable
                  placeholder="请选择"
                  size="small"
                  class="demo-form-select"
                >
                  <el-option
                    v-for="item in materialLibraryOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="广告位">
                <el-select
                  v-model="selectForm.spaceId"
                  clearable
                  placeholder="请选择"
                  size="small"
                  class="demo-form-select"
                >
                  <el-option
                    v-for="item in spaceOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="广告主" v-show="projectOrder.accountType === '1'">
                <el-input
                  v-model="selectForm.mediaPartnerName"
                  clearable
                  v-noEmoji
                  class="demo-form-input"
                  placeholder="请输入"
                  @keyup.enter.native="handleSearch"
                  maxlength="45"
                ></el-input>
              </el-form-item>
              <el-form-item label="计划单号">
                <el-input
                  v-model="selectForm.scheduleNo"
                  clearable
                  v-noEmoji
                  class="demo-form-input"
                  placeholder="请输入"
                  maxlength="45"
                  @keyup.enter.native="handleSearch"
                ></el-input>
              </el-form-item>
              <el-form-item label="订单编号">
                <el-input
                  v-model="selectForm.orderNo"
                  clearable
                  v-noEmoji
                  class="demo-form-input"
                  placeholder="请输入"
                  maxlength="45"
                  @keyup.enter.native="handleSearch"
                ></el-input>
              </el-form-item>
              <el-form-item label="物料校验码">
                <el-input
                  v-model="selectForm.mateCheckCode"
                  clearable
                  v-noEmoji
                  class="demo-form-input"
                  placeholder="请输入"
                  @keyup.enter.native="handleSearch"
                  maxlength="100"
                ></el-input>
              </el-form-item>
            </div>
            <div class="popover-title">素材</div>
            <div class="demo-form-box">
              <el-form-item label="素材状态">
              <el-select
                  v-model="selectForm.materialLibraryStatus"
                  clearable
                  placeholder="请选择"
                  size="small"
                  class="demo-form-select"
                >
                  <el-option
                    v-for="item in mediaStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="转码状态">
                <el-select
                  v-model="selectForm.transcodeStatus"
                  clearable
                  placeholder="请选择"
                  size="small"
                  class="demo-form-select"
                >
                  <el-option
                    v-for="item in transcodeStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="素材类型">
                <el-select clearable v-model="selectForm.materialLibraryType" class="demo-form-select">
                <el-option v-for="item in materialLibraryOptions"
                :key="'m'+item.value"
                :label="item.label"
                :value="item.value"
                >
                </el-option>
                </el-select>
              </el-form-item>
               <el-form-item label="素材时长">
                 <el-input
                  clearable
                  v-noEmoji
                  class="demo-form-input"
                  placeholder="请输入"
                  @keyup.enter.native="handleSearch"
                  maxlength="45"
                  v-model="selectForm.duration"></el-input>
              </el-form-item>
               <el-form-item label="广告位">
                <el-select
                  v-model="selectForm.materialLibrarySpaceId"
                  clearable
                  placeholder="请选择"
                  size="small"
                  class="demo-form-select"
                >
                  <el-option
                    v-for="item in spaceOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="广告主" v-show="projectOrder.accountType === '1'">
                <el-input
                  v-model="selectForm.materialLibraryPartnerName"
                  clearable
                  v-noEmoji
                  class="demo-form-input"
                  placeholder="请输入"
                  @keyup.enter.native="handleSearch"
                  maxlength="45"
                ></el-input>
              </el-form-item>
              <el-form-item label="媒体方">
                <el-select v-model="selectForm.cableCheckStatus" clearable placeholder="请选择" size="small" class="demo-form-select">
                  <el-option v-for="item in approveStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="牌照方">
                <el-select v-model="selectForm.auditStatus" clearable placeholder="请选择" size="small" class="demo-form-select">
                  <el-option v-for="item in auditStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <el-button size="small" type="primary" @click="handleSearch">筛选</el-button>
            <el-button size="small" @click="handleReset">重置</el-button>
          </el-form>
          <el-button
            slot="reference"
            icon="el-icon-arrow-down"
            class="popover-button"
            size="small"
          >全部筛选</el-button>
        </el-popover>
      </div>
      <div>
       <el-tag
        closable
        type="info"
        v-if="selectFormNum > 0"
        @close="handleClose"
        >
        {{selectFormNum}}个筛选条件
      </el-tag>
      </div>
      <div class="search-date">
        <el-date-picker
          size="small"
          v-model="projectOrder.timeList"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
    </div>
    <el-tabs
      :value="activeName"
      @input="handleChangeRouter"
      :class="isMounted ? 'table-tabs': 'table-tabs table-tabs--before-mount'"
    >
      <el-tab-pane
        v-for="item in putTabsLits"
        :label="item.title"
        :name="item.name"
        :key="item.title"
      >
        <span slot="label" @click.stop="handleChangeRouter(item.name)">{{item.title}}</span>
        <slot :name="item.name"></slot>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  inject: ['projectOrder'],
  data() {
    return {
      isMounted: false,
      selectForm: {},
      activeName: 'projectOrder',
      orderStatusOptions: this.$consts.orderStatuaOptions,
      scheduleStatusOptions: this.$consts.scheduleStatusOptions,
      mediaStatusOptions: this.$consts.materialStatusOptions,
      transcodeStatusOptions: this.$consts.transcodeStatusOptions,
      partnerOptions: [],
      spaceOptions: [],
      selectNameList: [
        { value: 0, label: '订单' },
        { value: 1, label: '计划' },
        { value: 2, label: '创意' },
        { value: 3, label: '素材' },
        { value: 4, label: '落地页' }
      ],
      selectSearchList: {
        0: 'projectOrder',
        1: 'adServingManage',
        2: 'materialCreative',
        3: 'materialManage',
        4: 'landingPage'
      },
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now() - 8.64e6
        // }
      },
      buyTypeOptions: [
        { value: 0, label: '合约排期' }
      ],
      saleTypeOptions: [],
      paymentOptions: [],
      sdkProviderList: [],
      scheduleSourceOptions: [],
      supportModeOptions: [
        { value: 0, label: '保价保量(PDB)' },
        { value: 1, label: '保价不保量(PD)' },
        { value: 2, label: '保价全量(CPDB)' }
      ],
      materialLibraryOptions: [],
      approveStatusOptions: [
        { value: 2, label: '不通过' }
      ],
      auditStatusOptions: [
        { value: 1, label: '通过' },
        { value: 2, label: '不通过' }
      ]
    }
  },
  props: ['activeType'],
  computed: {
    searchPlaceholder() {
      if (this.projectOrder.selectNameType === 0 || this.projectOrder.selectNameType === 1) {
        return '请输入单号/名称查询'
      } else {
        return '请输入ID/名称查询'
      }
    },
    putTabsLits() {
      const data = [
        {
          type: 0,
          name: 'projectOrder',
          title: '项目订单',
          show: this.$appState.$get('permissions')['orderTab']
        },
        {
          type: 1,
          name: 'adServingManage',
          title: '投放计划',
          show: this.$appState.$get('permissions')['scheduleTab']
        },
        {
          type: 2,
          name: 'materialCreative',
          title: '素材创意',
          show: this.$appState.$get('permissions')['scheduleMediaTab']
        },
        {
          type: 3,
          name: 'materialManage',
          title: '素材库',
          show: this.$appState.$get('permissions')['mediaTab']
        },
        {
          type: 4,
          name: 'landingPage',
          title: '落地页',
          show: this.$appState.$get('permissions')['landingPageTab']
        }
      ]
      const list = data.filter(item => item.show)
      return list
    },
    selectFormNum() {
      let validForm = {}
      for (let i in this.selectForm) {
        if (this.selectForm[i] || this.selectForm[i] === 0) {
          validForm[i] = this.selectForm[i]
        }
      }
      return Object.keys(validForm).length
    }
  },
  methods: {
    // handleSelectSearch() {
    //   let val = this.projectOrder.selectNameType
    //   if (this.activeName == this.selectSearchList[val]) {
    //     this.$emit('quickSearch')
    //   } else {
    //     this.$router.push({ name: this.selectSearchList[val] })
    //   }
    // },
    handleChangeRouter(val) {
      const curTab = this.putTabsLits.find(item => item.name === val)
      this.projectOrder.selectNameType = curTab ? curTab.type : 0
      this.$router.push({ name: val })
    },
    getBaseDict() {
      this.$service.getBaseDict().then(data => {
        this.paymentOptions = data.paymentList.map((item) => {
          return {
            label: item.dictLabel,
            value: parseInt(item.dictValue)
          }
        })
        this.spaceOptions = data.spaceList.map((item) => {
          return {
            label: item.spaceName,
            value: item.spaceId
          }
        })
        this.scheduleSourceOptions = JSON.parse(
          JSON.stringify(data.scheduleSourceList || [])
        )
          .filter(({ bizValue }) => bizValue !== 0)
          .map((item) => {
            return {
              label: item.bizLabel,
              value: item.bizValue
            }
          })
        this.saleTypeOptions = JSON.parse(JSON.stringify(data.saleTypeList || []))
          .filter(({ bizValue }) => bizValue !== 0)
          .map((item) => {
            return {
              label: item.bizLabel,
              value: item.bizValue
            }
          })
        this.sdkProviderList = (data.sdkProviderList || []).map(item => {
          return {
            providerName: item.dictLabel,
            providerNo: item.dictValue,
          }
        })
        this.$emit('setSdkProviderList', this.sdkProviderList)
      })
    },
    getMediaClass() {
      this.$service.getMediaClass().then(data => {
        this.materialLibraryOptions = data.map(item => {
          return {
            label: item.mediaClassName,
            value: item.mediaClassId
          }
        })
      })
    },
    handleSearch() {
      this.projectOrder.selectForm = this.cloneDeep(this.selectForm)
    },
    handleReset() {
      this.selectForm = this.projectOrder.genSelectForm()
      this.handleSearch()
    },
    handleClose() {
      this.handleReset()
    }
  },
  mounted() {
    this.isMounted = true
  },
  created() {
    if (this.activeType === 'projectOrder') {
      this.activeName = 'projectOrder'
      this.projectOrder.selectNameType = 0
    } else if (this.activeType === 'adServingManage') {
      this.activeName = 'adServingManage'
      this.projectOrder.selectNameType = 1
    } else if (this.activeType === 'materialCreative') {
      this.activeName = 'materialCreative'
      this.projectOrder.selectNameType = 2
    } else if (this.activeType === 'materialManage') {
      this.activeName = 'materialManage'
      this.projectOrder.selectNameType = 3
    } else {
      this.activeName = 'landingPage'
      this.projectOrder.selectNameType = 4
    }
    // 首页状态查询
    if (this.$route.params.scheduleStatus) {
      this.projectOrder.selectForm.scheduleStatus = this.$route.params.scheduleStatus
    }
    this.selectForm = this.cloneDeep(this.projectOrder.selectForm)
    this.getBaseDict()
    this.getMediaClass()
  }
}
</script>
<style lang="stylus" scoped>
.comment {
  position: relative;
  height: 100%;
}

.table-tabs {
  margin: 0 16px 16px 16px;
  background: #fff !important;
  border: none;
  > >>>.el-tabs__header {
    margin: 0;
    border-bottom: 1px solid #F0F2F5;
    padding: 0px 16px 0px;

    .el-tabs__nav-wrap:after {
      content: none;
    }
    .el-tabs__item {
      padding: 0;
      color: rgba(0, 0, 0, 0.65);
      height: 53px;
      width: 128px;
      text-align: center;
      padding-right: 32px;
    }
    .el-tabs__item.is-active, >>>.el-tabs__item :hover {
      color: #FF8B00;
    }
    .el-tabs__item span {
      font-size: 16px;
      display: block;
      width: 96px;
      height: 53px;
      line-height: 53px;
    }
    .el-tabs__active-bar {
      width: 96px !important;
    }
  }
}

.search-header {
  display: flex;
  flex-direction: row;
  padding: 15px 22px;
  margin-bottom: 16px;
  background: #fff;
  width: 100%;
  border-bottom: 1px solid #dcdfe6;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.06);
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.search-date {
  margin-left: auto;

  >>>.el-range-editor.el-input__inner {
    // width: 220px;
  }

  >>>.el-input__inner {
    color: rgba(0, 0, 0, 0.65);
  }
}

.content {
  margin-right: 10px;
}

>>>.el-table td, >>>.el-select-dropdown__item {
  color: rgba(0, 0, 0, 0.65);
}
.popover-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  padding-bottom: 11px;
}

// >>>.popover-title:first-child {
// }
.popover-button {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: 127px;
  font-size: 13px;
  height: 32px;
}

.input-with-select {
  >>>.el-input__inner:nth-child(2) {
    width: 174px;
    padding: 3px 10px 3px 10px;
  }

  >>>.el-input-group__append, >>>.el-input-group__prepend {
    color: rgba(0, 0, 0, 0.65);
  }

  >>>.el-input-group__prepend {
    width: 46px;
    background-color: #fff;
  }

  >>>.el-input-group__append {
    background: #f7f7f7;
    font-size: 12px;
    padding: 0px;
    width: 28px;
    text-align: center;
  }
}

>>> .el-select .el-input .el-select__caret {
  color: #333;
}

>>> .el-switch__core {
  height: 16px;
}

>>> .el-switch__core:after {
  width: 12px;
  height: 12px;
}

>>>.el-switch.is-checked .el-switch__core::after {
  margin-left: -14px;
}

.launch-content {
  height: calc(100vh - 60px);
  display: block;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
  overflow: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  .content-list {
    margin-top: 0;
  }

  .el-card {
    border-radius: 0;
  }
}

.demo-form {
  padding: 4px 10px 4px 24px;
  width: 98%;
}

.demo-form-box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-bottom: 18px;
}

.demo-form-box >>> .el-form-item {
  width: 22%;
  margin-right: 3%;
  margin-bottom: 8px;
}

.demo-form-box >>> .el-form-item:nth-child(4) {
  // margin-right: 0;
}

.demo-form-input, .demo-form-select, .demo-form-picker {
  width: 100%;
}

.el-form--inline .el-form-item {
  width: 24%;
}

>>>.el-tabs__item:focus.is-active.is-focus:not(:active) {
  box-shadow: none;
}

.table-tabs .table-tabs--before-mount {
  >>>.el-tabs__active-bar {
    transition: none;
  }
}

>>>.el-tabs__active-bar {
  transition: none;
}
</style>

<style lang="stylus">
.ad-popover
  width 90%
</style>
